export default (number) => {
    const ordinals = [
        "Zeroth", "First", "Second",
        "Third", "Fourth", "Fifth", "Sixth",
        "Seventh", "Eighth", "Ninth", "Tenth"
    ];
    return ordinals[number] || number;
}
;
